<template>
  <div>
    <DynamicComponent edc-id="polaris-mall-purchase" framework="Vue" :edc-dev="edcDev" />
  </div>
</template>

<script>
export default {
  name: 'PolarisMallPurchase',
  data() {
    return {
      edcDev: window.__EDC__.options.dev,
    }
  },
}
</script>
